<template>
		<div class="mt-5">
			<ModalConfirm ref="modalConfirm" :msg="msgConfirm" @action="claimReward"></ModalConfirm>
			<template v-if="!loading">
				<div class="d-flex d-lg-flex align-center justify-space-between mb-5">
					<div class="font-size-14 font-weight-bold secondary--text">Reward Royalti Peringkat</div>
				</div>
				
				<v-row>
					<v-col cols="12" sm="12" md="12" class="pb-0 mb-3" v-if="currentPoint">
						<div class="mr-n3 d-block d-sm-flex flex-row align-center justify-center">
							<v-col cols="12" sm="6" class="py-0 pl-0">
								<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-xl text-center d-flex flex-column align-stretch h-100 w-100" height="100">
									<div class="d-block cl-secondary font-size-12 font-weight-500"><span class="d-block font-weight-600">Titik Kiri Anda Saat Ini</span></div>
									<div class="d-flex flex-column align-center justify-center py-1">
										<div class="font-size-20 font-weight-600" :class="(currentPoint.network_total_node_left > 0) ? 'primary--text' : 'grey--text'">{{ currentPoint.network_total_node_left | toNumber }}</div>
									</div>
								</v-card>
							</v-col>

							<v-col cols="12" sm="6" class="py-0 pl-0">
								<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-xl text-center d-flex flex-column align-stretch h-100 w-100" height="100">
									<div class="d-block cl-secondary font-size-12 font-weight-500"><span class="d-block font-weight-600">Titik Kanan Anda Saat Ini</span></div>
									<div class="d-flex flex-column align-center justify-center py-1">
										<div class="font-size-20 font-weight-600" :class="(currentPoint.network_total_node_right > 0) ? 'primary--text' : 'grey--text'">{{ currentPoint.network_total_node_right | toNumber }}</div>
									</div>
								</v-card>
							</v-col>
						</div>
					</v-col>
				</v-row>

				<v-row class="ml-0" v-if="rewardPlanB.length > 0">
					<v-col cols="12" sm="6" md="6" lg="4" class="pl-0 pb-0 flex-stretch" v-for="reward in rewardPlanB" :key="reward.reward_id">
						<v-card class="elevation-0 rounded-xl hover-shadow fill-height" style="position: relative;" :class="(reward.reward_qualified_status == '') ? 'unqualified' : 'qualified'">
							<v-tooltip bottom v-if="reward.reward_qualified_status !== ''">
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										color="primary"
										elevation="2"
										fab
										rounded
										class="btn-download"
										:loading="loadingSave"
										:disabled="loadingSave"
										v-bind="attrs"
										v-on="on"
										@click="saveToImage(reward, myProfile, 'card-' + myProfile.member_network_code + '-' + reward.reward_qualified_reward_title.toLowerCase())"
									>
										<v-icon dense color="dark">mdi-download</v-icon>
									</v-btn>
								</template>
								<span>Simpan Gambar</span>
							</v-tooltip>

							<div class="d-flex flex-wrap">
								<v-col cols="12" class="d-flex flex-column align-center fill-height pa-4">
									<div class="d-flex flex-column align-center fill-height" style="height: 23.55rem; width: 100%;" :id="'card-' + myProfile.member_network_code + '-' + reward.reward_title.toLowerCase()">
										<!-- <v-img contain width="auto" height="23.55rem" elevation="2" class="mx-auto" :src="require(`/public/assets/reward/${reward.reward_id}.png`)"></v-img> -->
										<v-img contain width="auto" height="23.55rem" elevation="2" class="mx-auto" :src="reward.reward_image_url ? reward.reward_image_url : require('/public/assets/image/profile-pict.png')"></v-img>
										<div class="bottom-shadow" style="margin: 20px auto 20px;"></div>
										<template v-if="Object.keys(myProfile).length > 0">
											<div class="reward-member-image">
												<template v-if="reward.reward_qualified_status !== ''">
													<img class="rounded-pill" :src="myProfile.member_image_url_encript ? myProfile.member_image_url_encript : require('/public/assets/image/profile-pict.png')" />
												</template>
												<template v-else>
													<img class="rounded-pill" :src="require('/public/assets/image/profile-pict.png')" />
												</template>
											</div>
											<!-- <div class="reward-member-name font-size-10" :style="reward.reward_id == '1' || reward.reward_id == '2' ? 'top: 16.4rem' : 'top: 17rem'">{{ getName(myProfile.member_name) }} {{ reward.reward_id }}</div> -->
											<div v-if="reward.reward_qualified_status !== ''" class="reward-member-name font-size-10" :class="'reward-' + reward.reward_id" :style="getOffsetTop(reward.reward_id)">{{ getName(myProfile.member_name) }}</div>
										</template>
									</div>
								</v-col>
								<v-col cols="12" class="pl-0 pt-5 align-start">
									<div class="pt-2 pb-2 px-3">
										<div class="font-size-12 cl-primary font-weight-600 text-uppercase">{{ reward.reward_title }}</div>
									</div>
									<div class="d-flex flex-wrap">
										<v-col cols="12" class="pb-0 pt-1 d-flex flex-row align-center justify-space-between">
											<div class="font-size-9 cl-grey">Status Reward</div>
											<div class="font-size-9 cl-secondary font-weight-600 text-right">
												<v-chip
													small
													dense
													outlined
													:color="getRewardStatus(reward.reward_qualified_status).color"
													class="font-weight-bold white--text text-uppercase mb-2"
												><v-icon small class="mr-1">{{ getRewardStatus(reward.reward_qualified_status).icon }}</v-icon>{{ getRewardStatus(reward.reward_qualified_status).label }}</v-chip>
											</div>
										</v-col>
										<v-col cols="12" class="pb-0 d-flex flex-row align-center justify-space-between">
											<div class="font-size-10 cl-grey">Nominal Reward</div>
											<div class="font-size-11 cl-secondary font-weight-600 text-right">{{ reward.reward_value | toRupiah }}</div>
										</v-col>
										<v-col cols="12" class="pb-0 d-flex flex-row align-center justify-space-between">
											<div class="font-size-10 cl-grey">Syarat Titik Kiri</div>
											<div class="font-size-11 cl-secondary font-weight-600 text-right">{{ reward.reward_condition_node_left | toNumber }}</div>
										</v-col>
										<v-col cols="12" class="pb-0 d-flex flex-row align-center justify-space-between">
											<div class="font-size-10 cl-grey">Syarat Titik Kanan</div>
											<div class="font-size-11 cl-secondary font-weight-600 text-right">{{ reward.reward_condition_node_right | toNumber }}</div>
										</v-col>
										<v-col cols="12" class="pb-0 pt-3 d-flex flex-row align-center justify-space-between" v-if="reward.reward_qualified_status_datetime !== ''">
											<div class="font-size-9 cl-grey">Tanggal Qualified</div>
											<div class="font-size-9 cl-grey font-weight-600 text-right">{{ reward.reward_qualified_status_datetime | toDate }}</div>
										</v-col>
										<!-- <v-col cols="12" class="pb-0 pt-1 d-flex flex-row align-center justify-space-between" v-if="reward.reward_qualified_status !== 'pending'">
											<div class="font-size-9 cl-grey">{{ getRewardStatus(reward.reward_qualified_status).label }} pada</div>
											<div class="font-size-9 cl-grey font-weight-600 text-right">{{ reward.reward_qualified_status_datetime | toDate }}</div>
										</v-col> -->
										<v-col cols="12" class="d-flex flex-row align-center justify-space-between"></v-col>
										<template v-if="reward.reward_qualified_is_autoclaim == '0'">
											<v-col cols="12" class="d-flex flex-row align-center justify-center" v-if="reward.reward_can_be_claimed">
												<div class="pb-0 d-flex flex-row align-center justify-center mb-1">
													<v-btn block large depressed rounded color="success" class="px-5 white--text font-weight-bold" @click="showConfirmClaim(reward.reward_id, reward.reward_title)" v-if="reward.reward_is_already_claimed !== 'claimed'">
														<v-icon dense>mdi-medal-outline</v-icon>
														<span class="pl-1">Klaim Reward</span>
													</v-btn>
												</div>
											</v-col>
										</template>
									</div>
								</v-col>
							</div>
						</v-card>
					</v-col>
				</v-row>
				<div class="mt-3" v-if="rewardPlanB.length == 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-xl">
								<NoData></NoData>
								<div class="pt-3 text-center primary--text">Tidak ada data reward yang dapat ditampilkan</div>
							</v-card>
						</v-col>
					</v-row>
				</div>

				<div class="mt-3" v-if="rewardPlanB.length > 0">
					<v-row justify="end">
						<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
							<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="rewardPlanBPagination.total_page" @input="changePage"></v-pagination>
						</v-col>
						<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
							<div class=" font-size-10">Menampilkan {{ rewardPlanBPagination.total_display }} data dari total {{ rewardPlanBPagination.total_data }} data</div>
						</v-col>
						<v-col cols="4" sm="2" md="1">
							<v-autocomplete :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" item-color="red darken-3" @input="changeLimit"></v-autocomplete>
						</v-col>
					</v-row>
				</div>
			</template>

			<template v-else>
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</template>
		</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import html2canvas from 'html2canvas';
import ModalConfirm from '@/components/modals/vo-general/ModalKonfirmasi';

export default {
	props: ['network_code', 'currentPoint'],
	components: { ModalConfirm },
	data() {
		return {
			loading: false,
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
			rewardId: '',
			msgConfirm: '',
			rewardStatus: [
				{
					status: 'unqualified',
					color: 'secondary',
					label: 'Belum Qualified',
					icon: 'mdi-timer-sand'
				},
				{
					status: 'claimed',
					color: 'success',
					label: 'Sudah Klaim',
					icon: 'mdi-check-decagram-outline'
				},
				{
					status: 'approved',
					color: 'success',
					label: 'Disetujui',
					icon: 'mdi-check-decagram-outline'
				},
				{
					status: 'pending',
					color: 'warning',
					label: 'Menunggu',
					icon: 'mdi-timer-sand'
				},
				{
					status: 'rejected',
					color: 'error',
					label: 'Ditolak',
					icon: 'mdi-close-circle-outline'
				}
			],
			dataCard: null,
			loadingSave: false
		}
	},
	computed: {
		...mapState('reward', ['rewardPlanB', 'rewardPlanBPagination', 'rewardPlanBPoint']),
		...mapState('profil', ['myProfile']),
	},
	methods: {
		...mapActions('reward', ['getRewardPlanB', 'claimRewardPlanB']),
		...mapActions('profil', ['getProfileMitra']),

		capitalize(word) {
			if (word !== '' || word.length > 0) {
				let strWord = word.toLowerCase()
				return strWord
					.split('')
					.map((letter, index) =>
						index ? letter.toLowerCase() : letter.toUpperCase(),
					)
					.join('');
      } else {
				return ''
			}
    },
		getName(name) {
			let name_split = name.split(" ");
			let name_true = ''
			if (name_split.length > 1) {
				if (name_split.length > 2) {
					if (name_split[0].length == 0) {
						const lastname = (name_split[2] != '') ? ' ' + this.capitalize(name_split[2]) : ''
						name_true = this.capitalize(name_split[1]) + lastname
					} else {
						const lastname = (name_split[1] != '') ? ' ' + this.capitalize(name_split[1]) : ''
						name_true = this.capitalize(name_split[0]) + lastname
					}
				} else {
					const lastname = (name_split[1] != '') ? ' ' + this.capitalize(name_split[1]) : ''
					name_true = this.capitalize(name_split[0]) + lastname
				}
			} else {
				name_true = this.capitalize(name_split[0])
			}
			return name_true
		},
		getRewardStatus(status) {
			const reward = this.rewardStatus.find(x => x.status === status)
			if (reward) return reward
			else {
				const nonreward = {
					status: 'unqualified',
					color: 'secondary',
					label: 'Belum Qualified',
					icon: 'mdi-timer-sand'
				}
				return nonreward
			}
		},
		async getData() {
			this.loading = true
			await this.getProfileMitra()
			this.getRewardPlanB(this.queryString({ network_code: this.network_code, limit:this.limit, page: this.page, params:this.params })).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		getOffsetTop(id) {
			let tops = '0'
			switch (id) {
				case '1':
					tops = 'top: 17.6rem'
					break;
				case '2':
					tops = 'top: 17.6rem'
					break;
				case '3':
					tops = 'top: 17.6rem'
					break;
				case '4':
					tops = 'top: 17.6rem'
					break;
				case '5':
					tops = 'top: 17.6rem'
					break;
				case '6':
					tops = 'top: 17.6rem'
					break;
				case '7':
					tops = 'top: 17.6rem'
					break;

				default:
					tops = '0'
					break;
			}

			return tops;
		},
		saveToImage(reward, profile, id) {
			this.loadingSave = true
			var node = document.getElementById(id);
			var member = profile
			this.dataCard = reward
					
			setTimeout(() => {
				html2canvas(node, { scale: 4 }).then(canvas => {
					this.saveAs(canvas.toDataURL(), 'reward_' + reward.reward_qualified_reward_title.toLowerCase() + '_' + member.member_network_code + '.png');
				});
			}, 6000);

		},
		saveAs(uri, filename) {
			var link = document.createElement('a');

			if (typeof link.download === 'string') {
				link.href = uri;
				link.download = filename;
				document.body.appendChild(link);

				//simulate click
				link.click();

				//remove the link when done
				document.body.removeChild(link);
			} else {
				window.open(uri);
			}

			this.loadingSave = false
		},
		showConfirmClaim(id, title) {
			this.rewardId = id
			this.msgConfirm = `<div>Apakah Anda yakin ingin mengklaim reward <span style="color: #C59042; font-weight: bold">${title}</span>?<div>`
			this.$refs.modalConfirm.modalShow()
		},
		claimReward() {
			this.$refs.modalConfirm.loadingButton()
			this.claimRewardTour({reward_qualified_id: this.rewardId}).then(()=> {
				this.$refs.modalConfirm.loadingButton()
				this.$refs.modalConfirm.modalHide()
				this.getData()
			}).catch(()=> {
				this.$refs.modalConfirm.normalButton()
			})
		},
	},
	created(){
		this.$store.dispatch('setPageTitle', `List Reward Royalti Peringkat`)
		this.getData()
	}
};
</script>

<style scoped>
.reward-member-image {
	position: absolute;
	/* top: 8rem;
	margin-left: 4.5px; */
	top: 5.75rem;
	margin-left: 7.5px;
}
.reward-member-image img {
	width: 8.5rem;
	height: 8.5rem;
}
.reward-member-name {
	position: absolute;
	color: #000;
	font-weight: bold;
}

.btn-download {
	display: block;
	position: absolute;
	top: 5px;
	left: 5px;
	z-index: 1;
	border-radius: 100%;
}

.unqualified {
	filter: grayscale(1)!important;
	opacity: 0.75!important;
}

.unqualified:before {
	content: '';
	position: absolute;
	width: 300px;
	height: 300px;
	background: url('/assets/image/unqualified.png') center center no-repeat;
	background-size: cover;
	top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
	z-index: 10;
}

@media (max-width: 399px) {
	.reward-member-name {
		margin-top: -16px;
	}

	.reward-member-name.reward-1 {
		margin-top: -17px;
	}

	.reward-member-name.reward-2 {
		margin-top: -17px;
	}

	.reward-member-name.reward-3 {
		margin-top: -17px;
	}

	.reward-member-name.reward-4 {
		margin-top: -17px;
	}

	.reward-member-name.reward-5 {
		margin-top: -17px;
	}

	.reward-member-name.reward-6 {
		margin-top: -17px;
	}

	.reward-member-name.reward-7 {
		margin-top: -17px;
	}
}

@media (min-width: 400px) and  (max-width: 599px) {
	.reward-member-name {
		margin-top: -3px;
	}

	.reward-member-name.reward-1 {
		margin-top: -15px;
	}

	.reward-member-name.reward-2 {
		margin-top: -15px;
	}

	.reward-member-name.reward-3 {
		margin-top: -15px;
	}

	.reward-member-name.reward-4 {
		margin-top: -15px;
	}

	.reward-member-name.reward-5 {
		margin-top: -15px;
	}

	.reward-member-name.reward-6 {
		margin-top: -15px;
	}

	.reward-member-name.reward-7 {
		margin-top: -15px;
	}
}

@media (min-width: 768px) and (max-width: 991.98px) {
	.reward-member-name {
		margin-top: -5px;
	}

	.reward-member-name.reward-1 {
		margin-top: -8px;
	}

	.reward-member-name.reward-2 {
		margin-top: -8px;
	}

	.reward-member-name.reward-3 {
		margin-top: -8px;
	}

	.reward-member-name.reward-4 {
		margin-top: -8px;
	}

	.reward-member-name.reward-5 {
		margin-top: -8px;
	}

	.reward-member-name.reward-6 {
		margin-top: -8px;
	}

	.reward-member-name.reward-7 {
		margin-top: -8px;
	}
}

@media (min-width: 1200px) and (max-width: 1399.98px) {
	.reward-member-name {
		margin-top: -18px;
	}

	.reward-member-name.reward-1 {
		margin-top: -22px;
	}

	.reward-member-name.reward-2 {
		margin-top: -22px;
	}

	.reward-member-name.reward-3 {
		margin-top: -22px;
	}

	.reward-member-name.reward-4 {
		margin-top: -22px;
	}

	.reward-member-name.reward-5 {
		margin-top: -22px;
	}

	.reward-member-name.reward-6 {
		margin-top: -22px;
	}

	.reward-member-name.reward-7 {
		margin-top: -22px;
	}
}

@media (min-width: 1400px) and (max-width: 1499.98px) {
	.reward-member-name {
		margin-top: -18px;
	}

	.reward-member-name.reward-1 {
		margin-top: -7px;
	}

	.reward-member-name.reward-2 {
		margin-top: -7px;
	}

	.reward-member-name.reward-3 {
		margin-top: -7px;
	}

	.reward-member-name.reward-4 {
		margin-top: -7px;
	}

	.reward-member-name.reward-5 {
		margin-top: -7px;
	}

	.reward-member-name.reward-6 {
		margin-top: -7px;
	}

	.reward-member-name.reward-7 {
		margin-top: -7px;
	}
}
</style>